var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigatorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 302,
    viewBox: "0 0 301 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.778 179.149C288.898 214.69 269.266 246.442 240.648 268.471V258.166C266.734 231.761 281.918 212.579 288.657 177.77C295.426 142.802 288.714 106.567 269.868 76.343C251.022 46.1194 221.438 24.1456 187.059 14.8351C154.385 5.98659 110.141 11.0057 77.1534 29.5027L81.7216 19.4315C114.736 2.24575 153.014 -1.9 188.955 7.83328C225.103 17.6227 256.208 40.7267 276.023 72.5048C295.838 104.283 302.896 142.382 295.778 179.149ZM4.52497 123.204C11.3015 87.6481 30.8382 55.8429 59.3867 33.7314V42.716C34.4055 63.6192 18.2535 89.9177 11.6507 124.562C4.98246 159.55 11.7994 195.766 30.7325 225.935C49.6655 256.104 79.3124 277.992 113.719 287.203C147.843 296.339 176.521 292.306 200.339 281.951L214.627 284.525C182.689 299.934 146.216 303.413 111.843 294.211C75.6667 284.526 44.495 261.512 24.5882 229.791C4.68132 198.07 -2.48628 159.992 4.52497 123.204Z",
    stroke: "#A0325E",
    strokeWidth: 3.76728
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigatorCircle);
export default __webpack_public_path__ + "static/media/navigator-circle.a6a0bd9f5b626e6784a3d138cc1a7c15.svg";
export { ForwardRef as ReactComponent };